// config.js
const API_BASE_URL = "https://prodapi.iworkkz.com:9096/API";
//const API_BASE_URL = "https://starsapb1hps.starengineers.in:8084/API";

//const API_BASE_URL = "http://192.168.100.221:8085//api";

export { API_BASE_URL };
